<template>
  <div class="wrap">

    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper">

      <!-- form-title-wrap -->
      <div class="form-title-wrap">
        <form-title :tip="tip" :flag="flag" :tip3="tip3"></form-title>
      </div>
      <!-- form-title-wrap -->


      <div class="edit-form">

        <div class="edit-form-wrap" >
          <el-form
            :model="editForm"
            :rules="rules"
            ref="editForm"
            label-width="100px"
            class="form"
          >

            <el-form-item label="旧密码" prop="oldpassword">
                <el-input
                  type="password"
                  v-model="editForm.oldpassword"
                  placeholder="请填写旧密码"
                  clearable
                  show-password
                  autoComplete="off"
                />
            </el-form-item>


            <el-form-item label="新密码" prop="password">
              <el-input
                type="password"
                v-model="editForm.password"
                clearable
                show-password
                placeholder="密码长度在6-20位字符之间"
                autoComplete="off"
              />
            </el-form-item>

            <el-form-item label="确认新密码" prop="password2">
              <el-input
                type="password"
                v-model="editForm.password2"
                clearable
                show-password
                placeholder="请重新输入一下新的密码"
                autoComplete="off"
              />
            </el-form-item>


            <div class="form-opts" >
              <el-button type="primary" @click="submit('editForm')">
                保存
              </el-button>
              <el-button type="info"  @click="cancelOpt" >
                取消
              </el-button>
            </div>


          </el-form>
        </div>

      </div>


    </div>
  </div>
</template>

<script>
import formTitle from '../common/formTitle';
import { getLoginUser } from '../../utils/auth';
import { changeOldpwd } from '../request/regAndEdit';
import { Message } from 'element-ui';



export default {
  name: 'editPw',
  components: {
    formTitle
  },
  data() {
    //身份证验证

    //密码验证
    let checkPassword = (rule, value, callback) => {
     
      // 是否包含一位数字
      // const regNumber = /(?=.*[\d])/
      // // 是否包含一位字母
      // const regLetter = /(?=.*[a-zA-Z])/
      // // 是否包含一位特殊字符
      // const regCharacter = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
      if (!value || value == '') {
        callback(new Error('密码不能为空!'));
        return;
      } 
      if (value.length > 20 || value.length < 6) {
          callback(new Error('密码长度为6-20位!'));
          return;
      }

      // if (!regNumber.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      // if (!regLetter.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      // if (!regCharacter.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      callback()

    }
    //确认密码
    let checkPassword2 = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请重复输入密码'));
        return;
      }  
      if (value !== this.editForm.password) {
        callback(new Error('两次输入密码不一致'));
        return;
      }
      callback()
    }



    return {
      editForm: {
        oldpassword: '',
        password: '',
        password2: ''
      },
      show: true,
      disabledCodeBtn: true,
      count: '',
      timer: null,
      tip: '修改密码',
      // 温馨提示: 注册完成后,证件类型,证件号码将不能修改
      tip3: '',
      flag: true,
      rules: {
        oldpassword: [
          { required: true, message: '请填写旧密码', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: checkPassword, trigger: 'blur' }
        ],
        password2: [
          { required: true, validator: checkPassword2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    //修改完成提交
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.newPwd()
        } else {
          return false
        }
      })
    },
    //新密码
    newPwd() {

      let user = getLoginUser();
      if(!user) {
        console.log("用户信息错误!");
        return;
      }

      let params = {
        oldpwd: this.editForm.oldpassword,
        newpwd: this.editForm.password,
        username: user['userName']
      }

      changeOldpwd(params).then(res => {
        
        if(res.success) {
          Message({
                type: 'success',
                message: res.message
          });
        } else {
            Message({
                type: 'warning',
                message: res.message
            });
        }

      });


    },
    cancelOpt() {
      this.$router.push("/");
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>



.wrap {

  .wrapper {
    width: auto;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 20px;
    padding-bottom: 40px;
  }

  .form-title-wrap {
    line-height: 40px;
    margin-bottom: 12px;
  }

  .edit-form {
    margin: 0 auto;
    background: #fff;
    border-radius: 4px;
    padding: 12px;
  }

  .edit-form-wrap {
      margin: 0 auto;
  }

  .form-opts {
    text-align: center;
  }


}



@media screen and (min-width: 320px) { 

}

@media screen and (min-width: 480px) { 
    
}
/* 移动 */
@media screen and (min-width: 576px) { 
    
}
/* 平板 */
@media screen and (min-width: 768px) { 

}

/* PC */
@media screen and (min-width: 992px) {

}
@media screen and (min-width: 1200px) {

  .wrap {

    .wrapper {
      width: 1200px;
      padding-left: 0;
      padding-right: 0;
    }


  }

}





</style>
